import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Najmul Hasan </span>
            from <span className="purple">Dhaka,Bangladesh.</span>
            <br />I have completed my graduation in{" "}
            <span className="purple">
              Electrical and Electronic Engineering{" "}
            </span>
            from <strong className="purple">Eastern University.</strong>
            <br />
            <br />I always focus on learning new technology. Apart from coding,
            some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Computer Games & Football
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Teaching
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
